"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHoverCursor = exports.getMouseState = exports.isMiddleFirstDownAndUneaten = exports.isMiddleDownAndUneaten = exports.isRightFirstDownAndUneaten = exports.isRightDownAndUneaten = exports.isLeftFirstUpAndUneaten = exports.isLeftFirstDownAndUneaten = exports.isLeftDownAndUneaten = exports.isLeftFirstUpRegardless = exports.isLeftUpRegardless = exports.isLeftFirstDownRegardless = exports.isLeftDownRegardless = exports.reset = exports.tempEat = exports.isUsingPointerPosition = exports.tempEatCursor = exports.isCursorEaten = exports.isEatenLeft = exports.isEatenAll = exports.updateAll = exports.create = void 0;
var assert_sidecar_1 = require("../lib/assert-sidecar");
var common_sidecar_1 = require("../main/common-sidecar");
var game_1 = require("../main/game");
// let list: string[] = []
var _eatenTimerAll = 0;
var _eatenTimerLeft = 0;
// let eatenTimerMiddle = 0
// let eatenTimerRight = 0
var _cursorEatenTimer = 0;
var _nextPointer = 'default';
function createPointerState() {
    return {
        isReleased: true,
        isDown: false,
        isFirstDown: false,
        isFirstDownPrimer: false,
        isFirstUp: false,
        isFirstUpPrimer: false,
    };
}
function release(state) {
    state.isReleased = true;
    state.isFirstUpPrimer = true;
    state.isDown = false;
    state.isFirstDown = false;
    state.isFirstDownPrimer = false;
}
function press(state) {
    state.isReleased = false;
    state.isFirstUpPrimer = false;
    state.isFirstUp = false;
    state.isDown = true;
    state.isFirstDownPrimer = true;
}
function pressOrRelease(state, isDown) {
    if (!state.isDown && isDown) {
        press(state);
    }
    if (state.isDown && !isDown) {
        release(state);
    }
}
function usePrimers(state) {
    state.isFirstDown = false;
    state.isFirstUp = false;
    if (state.isFirstDownPrimer) {
        state.isFirstDownPrimer = false;
        state.isFirstDown = true;
        state.isDown = true;
    }
    else if (state.isFirstUpPrimer) {
        state.isFirstUpPrimer = false;
        state.isFirstUp = true;
        state.isDown = false;
    }
}
function resetState(state) {
    state.isReleased = true;
    state.isDown = false;
    state.isFirstDown = false;
    state.isFirstDownPrimer = false;
    state.isFirstUp = false;
    state.isFirstUpPrimer = false;
}
var _left = createPointerState();
var _pointer1 = createPointerState();
var _middle = createPointerState();
var _right = createPointerState();
var _isCreated = false;
function create() {
    assert_sidecar_1.assert.f(_isCreated);
    _isCreated = true;
    var ps = common_sidecar_1.common.getPhaserScene();
    ps.input.on('pointerup', function (pointer) {
        // console.log('pu', pointer)
        if (pointer.button === 0) {
            release(_left);
        }
        if (pointer.button === 1) {
            release(_middle);
        }
        if (pointer.button === 2) {
            release(_right);
        }
    });
    ps.input.on('pointerdown', function (pointer) {
        if (pointer.button === 0) {
            press(_left);
        }
        if (pointer.button === 1) {
            press(_middle);
        }
        if (pointer.button === 2) {
            press(_right);
        }
    });
}
exports.create = create;
// export function update(name: string, isOpen: boolean) {
//   if (isOpen) {
//     list.push(name)
//     tempEat()
//   } else {
//     if (list.indexOf(name) !== -1) {
//       tempEat()
//       list = l.filter(list, (c) => c !== name)
//     }
//   }
// }
function updateAll() {
    // if()
    var sc = common_sidecar_1.common.getPhaserScene();
    var input = sc.input;
    // console.log('pointer state', input.pointer1.isDown)
    pressOrRelease(_pointer1, input.pointer1.isDown);
    usePrimers(_left);
    usePrimers(_middle);
    usePrimers(_right);
    usePrimers(_pointer1);
    if (_pointer1.isFirstUp) {
        game_1.mobileGoFullscreen();
    }
    _eatenTimerAll--;
    if (!_left.isDown) {
        _eatenTimerLeft--;
    }
    if (_cursorEatenTimer > 0) {
        _cursorEatenTimer--;
    }
    common_sidecar_1.common.getPhaserScene().game.canvas.style.cursor = _nextPointer;
    _nextPointer = 'default';
}
exports.updateAll = updateAll;
function isEatenAll() {
    return _eatenTimerAll > 0; //  || list.length > 0
}
exports.isEatenAll = isEatenAll;
function isEatenLeft() {
    return _eatenTimerLeft > 0; //  || list.length > 0
}
exports.isEatenLeft = isEatenLeft;
function isCursorEaten() {
    return _cursorEatenTimer > 0;
}
exports.isCursorEaten = isCursorEaten;
function tempEatCursor() {
    _cursorEatenTimer = 1;
}
exports.tempEatCursor = tempEatCursor;
function isUsingPointerPosition() {
    return _pointer1.isDown || _pointer1.isFirstUp;
}
exports.isUsingPointerPosition = isUsingPointerPosition;
function tempEat() {
    _left.isReleased = false;
    _middle.isReleased = false;
    _right.isReleased = false;
    _pointer1.isReleased = false;
    _eatenTimerAll = 3;
    _eatenTimerLeft = 3;
}
exports.tempEat = tempEat;
function reset() {
    resetState(_left);
    resetState(_middle);
    resetState(_right);
    resetState(_pointer1);
    tempEat();
}
exports.reset = reset;
function isLeftDownRegardless() {
    return _left.isDown || _pointer1.isDown;
}
exports.isLeftDownRegardless = isLeftDownRegardless;
function isLeftFirstDownRegardless() {
    return _left.isFirstDown || _pointer1.isFirstDown;
}
exports.isLeftFirstDownRegardless = isLeftFirstDownRegardless;
function isLeftUpRegardless() {
    return !_left.isDown && !_pointer1.isDown;
}
exports.isLeftUpRegardless = isLeftUpRegardless;
function isLeftFirstUpRegardless() {
    return _left.isFirstUp || _pointer1.isFirstUp;
}
exports.isLeftFirstUpRegardless = isLeftFirstUpRegardless;
function isLeftDownAndUneaten() {
    return isLeftDownRegardless() && !isEatenAll();
}
exports.isLeftDownAndUneaten = isLeftDownAndUneaten;
function isLeftFirstDownAndUneaten() {
    return isLeftFirstDownRegardless() && !isEatenAll();
}
exports.isLeftFirstDownAndUneaten = isLeftFirstDownAndUneaten;
function isLeftFirstUpAndUneaten() {
    return isLeftFirstUpRegardless() && !isEatenAll();
}
exports.isLeftFirstUpAndUneaten = isLeftFirstUpAndUneaten;
function isRightDownAndUneaten() {
    return _right.isDown && !isEatenAll();
}
exports.isRightDownAndUneaten = isRightDownAndUneaten;
function isRightFirstDownAndUneaten() {
    return _right.isFirstDown && !isEatenAll();
}
exports.isRightFirstDownAndUneaten = isRightFirstDownAndUneaten;
function isMiddleDownAndUneaten() {
    return _middle.isDown && !isEatenAll();
}
exports.isMiddleDownAndUneaten = isMiddleDownAndUneaten;
function isMiddleFirstDownAndUneaten() {
    return _middle.isFirstDown && !isEatenAll();
}
exports.isMiddleFirstDownAndUneaten = isMiddleFirstDownAndUneaten;
function getMouseState() {
    return {
        left: isLeftDownAndUneaten(),
        leftFirst: isLeftFirstDownAndUneaten(),
        right: isRightDownAndUneaten(),
        rightFirst: isRightFirstDownAndUneaten(),
        middle: isMiddleDownAndUneaten(),
        middleFirst: isMiddleFirstDownAndUneaten(),
    };
}
exports.getMouseState = getMouseState;
function setHoverCursor() {
    common_sidecar_1.common.getPhaserScene().game.canvas.style.cursor = 'pointer';
    _nextPointer = 'pointer';
}
exports.setHoverCursor = setHoverCursor;
